// extracted by mini-css-extract-plugin
export default {"gallery":"Gallery_gallery__d5VzA","title":"Gallery_title__sbTQ3","subText":"Gallery_subText__nUx3v","galleryBody":"Gallery_galleryBody__Msr4a"};